import * as React from 'react';
import {Property} from 'csstype';
import {theme} from '../style';

interface LabelProps {
  label: string;
  location?: {x: number; y: number};
  fontFamily?: Property.FontFamily;
  fontSize?: Property.FontSize<number>;
  fill?: Property.Fill;
  fontWeight?: Property.FontWeight;
  textAnchor?: Property.TextAnchor;
  dominantBaseline?: Property.DominantBaseline;
  transform?: string;
}

/**
 * Draw a label on the chart.
 *
 * @param label - the text for the label
 * @param location - where to draw, in unscaled x/y space
 * @param fontFamily the font family. default to theme
 * @param fontSize - the font size. default 7
 * @param fill - the fill. default to theme
 * @param fontWeight - the fontWeight. default bold
 * @param textAnchor - the textAnchor. default end
 * @param dominantBaseline - the optional dominantBaseline
 * @param transform - the optional transform
 */
export const Label = ({
  label,
  location,
  fontFamily = theme.fonts.primaryFontFamily,
  fontSize = 7,
  fill = theme.colors.chartTextPrimary,
  fontWeight = 'bold',
  textAnchor = 'end',
  dominantBaseline,
  transform,
}: LabelProps) => (
  <text
    x={location && location.x}
    y={location && location.y}
    fontFamily={fontFamily}
    fontSize={fontSize}
    fill={fill}
    fontWeight={fontWeight}
    textAnchor={textAnchor}
    dominantBaseline={dominantBaseline}
    transform={transform}>
    {label}
  </text>
);
